import enLang from './entries/en-US';
import deLang from './entries/de_DE';

const AppLocale: any = {
  en: enLang,
  de: deLang
};

export default AppLocale;
 